import React from 'react';
import { Notification } from '.';
import {
  AlbumIcon,
  CalendarIcon,
  ChatIcon,
  ClipboardIcon,
  FavStarIcon,
  GeoPinIcon,
  GiftIcon,
  GroupIcon,
  HandIcon,
  HeartsIcon,
  InviteIcon,
  MailIcon,
  MobileHomeIcon,
  MonitorIcon,
  PiggyBankIcon,
  PricePointsIcon,
  Storefronticon,
  TruckIcon,
} from '../SvgIcons';
import ChecklistIcon from '../SvgIcons/Checklist';

const notificationMapper = (itemType?: string): JSX.Element => {
  switch (itemType) {
    case Notification.PRODUCT_WEDDING_DOWNLOAD_CHECKLIST_CONVERSION_FIRST:
      return <ChecklistIcon />;
    case Notification.PRODUCT_WEDDING_SUPER_LINK_CONVERSION_FIRST:
      return <GroupIcon />;
    case Notification.PRODUCT_MARKETPLACE_VENDOR_CONVERSION_FIRST:
    case Notification.PRODUCT_MARKETPLACE_VENDOR_CONVERSION_SECOND:
    case Notification.INQUIRY_STOREFRONT_CONNECTED_BOOKED_STATE_STATUS:
    case Notification.MARKETPLACE_STOREFRONT_FAVORITED:
      return <Storefronticon />;
    case Notification.PRODUCT_WEDDING_ADD_EVENT_CONVERSION_FIRST:
    case Notification.PRODUCT_WEDDING_WEBSITE_CONVERSION_FIRST:
    case Notification.PRODUCT_WEDDING_WEBSITE_CONVERSION_SECOND:
      return <MonitorIcon />;
    case Notification.PRODUCT_WEDDING_GUESTLIST_CONVERSION_FIRST:
    case Notification.POST_WEDDING_FIRST_REFER_FRIENDS:
      return <GroupIcon />;
    case Notification.PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_FIRST:
    case Notification.PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_SECOND:
    case Notification.POST_WEDDING_FIRST_SEND_THANK_YOU_CARDS:
    case Notification.POST_WEDDING_FIRST_PROMOTE_HOLIDAY_CARDS:
      return <InviteIcon />;
    case Notification.ADDRESS_COLLECTED:
      return <GeoPinIcon />;
    case Notification.GIFT_RECEIVED:
    case Notification.SURPRISE_GIFT_REVEALED:
    case Notification.PRODUCT_REGISTRY_CONVERSION_FIRST:
    case Notification.POST_WEDDING_FIRST_SHIP_GIFTS:
      return <GiftIcon />;
    case Notification.INQUIRY_STOREFRONT_CONNECTED:
    case Notification.INQUIRY_STOREFRONT_CONNECTED_FIRST_REPLY_REMINDER:
    case Notification.INQUIRY_STOREFRONT_CONNECTED_SECOND_REPLY_REMINDER:
      return <ChatIcon />;
    case Notification.ORDER_SHIPPED:
      return <TruckIcon />;
    case Notification.RSVP:
      return <CalendarIcon />;
    case Notification.WELCOME:
      return <HandIcon />;
    case Notification.WEDDING_DAY_CONGRATS:
      return <HeartsIcon />;
    case Notification.COMPLETION_DISCOUNT_AWARDED:
      return <PricePointsIcon />;
    case Notification.POST_WEDDING_FIRST_CREATE_WEDDING_ALBUM:
      return <AlbumIcon />;
    case Notification.POST_WEDDING_FIRST_READ_EXPERT_ADVICE:
      return <ClipboardIcon />;
    case Notification.ORDER_DELIVERED:
      return <MobileHomeIcon />;
    case Notification.FUNDS_TRANSFER_PAID:
      return <PiggyBankIcon />;
    case Notification.COMMERCE_PRODUCT_REVIEW_REQUESTED:
    case Notification.POST_WEDDING_FIRST_REVIEW_MARKETPLACE_VENDOR:
      return <FavStarIcon />;
    default:
      return <MailIcon />;
  }
};

export default notificationMapper;
